import { render, staticRenderFns } from "./selectNewComponent.vue?vue&type=template&id=2f962700&"
import script from "./selectNewComponent.vue?vue&type=script&lang=js&"
export * from "./selectNewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports